export default __webpack_public_path__ + "static/media/RUBRIQUE_KOJY_REDAC.d0503f73.png";